import { SnowplowService } from 'wanderu-service-analytics';

function scheduleSelected({ date, showBoolean }) {
    SnowplowService.fireStructuredEvent({
        category: 'c2c_schedule_table',
        label: showBoolean
            ? 'schedule_table_see_less'
            : 'schedule_table_see_more',
        action: 'click',
        property: JSON.stringify({
            date,
        }),
    });
}

export default { scheduleSelected };
